<script setup>
/* Vereinslogo eines transferierten Spielers (Bild im geschützten Speicher).
   Ohne Pfad oder solange das Bild lädt, wird nichts gezeichnet — kein
   Platzhalterkasten in der Liste. Genutzt in der Liste (TransferredRow.vue)
   und in Player Info (SectorPass.vue). */
import { useStoredImage } from '../composables/useStoredImage.js';

const props = defineProps({
  path: { type: String, default: null },
  size: { type: Number, default: 24 },
});

const { url } = useStoredImage(() => props.path);
</script>

<template>
  <img
    v-if="url"
    class="club-logo"
    :src="url"
    :style="{ width: size + 'px', height: size + 'px' }"
    alt=""
  />
</template>

<style scoped>
.club-logo {
  flex: none;
  object-fit: contain;
  border-radius: 4px;
}
</style>
